import type { AutosuggestProps } from 'react-autosuggest';

import { dynamic } from '#/utils/dynamic';

const InternalDynamicAutosuggest = dynamic(() => import('react-autosuggest'), {
  strategy: 'client-only',
});

/**
 * We need to wrap react-autosuggest because it breaks during RSC
 */
export function DynamicReactAutosuggest<
  // oxlint-disable-next-line typescript/no-explicit-any
  TSuggestion = any,
  // oxlint-disable-next-line typescript/no-explicit-any
  TSection = any,
>(props: AutosuggestProps<TSuggestion, TSection>) {
  return (
    // @ts-expect-error it's correct, we're just forwarding props
    <InternalDynamicAutosuggest
      // oxlint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
}
